<template>
  <v-layout row wrap>
    <v-card class="w100">
      <v-card-title primary-title>
        <div class="H5-Primary-Left">Notification Name</div>
      </v-card-title>
      <div class="v-card-content">
        <v-layout>
          <v-flex xs12 md7>
            <v-layout class="wrap">
              <v-flex xs12>
                <v-text-field v-model="name" label="Notification Name" :rules="nameRules" />
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  outline
                  auto-grow
                  label="Notification Description"
                  rows="4"
                  v-model="description"
                  :rules="descriptionRules"
                  maxlength="240"
                  counter="240"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </v-layout>
</template>

<script>
import rules from '@/rules';

export default {
  props: ['notification'],
  data: () => ({
    nameRules: [rules.required('Notification Name is Required')],
    descriptionRules: [rules.required('Notification Description is Required')],
  }),
  computed: {
    notifProxy: {
      get() {
        return this.notification;
      },
      set(value) {
        this.$emit('update:notification', value);
      },
    },
    name: {
      get() {
        return this.notification.title;
      },
      set(value) {
        this.$set(this.notifProxy, 'title', value);
      },
    },
    description: {
      get() {
        return this.notification.description;
      },
      set(value) {
        this.$set(this.notifProxy, 'description', value);
      },
    },
  },
  watch: {
    name() {
      this.$emit('update:isNameUnique', true);
    },
  },
};
</script>
